export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13601.34cc352d.jpg";